// Angular
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-field-single-radio-sm',
    templateUrl: './field-single-radio-sm.component.html',
    styleUrls: ['./field-single-radio-sm.component.scss'],
    standalone: false
})
export class FieldSingleRadioSmComponent {
    @Input() model = false;
}
